import { render, staticRenderFns } from "./senders-table.vue?vue&type=template&id=18af7068&"
import script from "./senders-table.vue?vue&type=script&lang=js&"
export * from "./senders-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports